import React, { FC, forwardRef } from 'react';
import { FieldOptionBase } from 'api/tasks';
import { FieldHelper } from 'utils/field';
import { SingleSelectField } from '../fields';
import { EditableProps } from './editable-props';
import { NoValue } from './no-value';
import { SelectFieldOption } from './option';
import { StyledSelect } from './styled-select';

interface Props extends Partial<EditableProps<number>> {
  field: SingleSelectField;
}

export const SingleSelectFieldValue: FC<Props> = forwardRef(
  ({ field, editable, onChange }, ref) => {
    const {
      options: { activeOptions, allOptions },
    } = FieldHelper(field);

    return !editable ? (
      field.value == null ? (
        <NoValue />
      ) : (
        <SelectFieldOption
          option={allOptions.find((x) => x.value === field.value)!}
        />
      )
    ) : (
      <StyledSelect
        ref={ref}
        type="tag"
        isClearable
        menuIsOpen
        options={activeOptions}
        value={
          field?.value == null
            ? null
            : allOptions.find((x) => x.value === field?.value)
        }
        onChange={(latest: FieldOptionBase) => onChange?.(latest?.value)}
      />
    );
  },
);
